import React from 'react'
import LeadGenerationElements from '../LeadGenerationElements'

const EmptySearchResult: React.FC = () => {
  return <LeadGenerationElements isEmptySearch />
}

export default EmptySearchResult
